/**
 * @generated SignedSource<<9095b5dd69b4238d53bbc2293313a78a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_Card_issue$data = {
  readonly isResolved: boolean | null | undefined;
  readonly key: string;
  readonly " $fragmentType": "main_issueNavigator_Card_issue";
};
export type main_issueNavigator_Card_issue$key = {
  readonly " $data"?: main_issueNavigator_Card_issue$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Card_issue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_Card_issue",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "key"
      },
      "action": "THROW",
      "path": "key"
    },
    {
      "kind": "ScalarField",
      "name": "isResolved"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "e3f34b125801c49c601cb9bbb61a7a14";

export default node;
